/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useCallback, useEffect, useRef,
} from 'react';
import Shimmer from 'react-shimmer-effect';
import { useDispatch, useSelector } from 'react-redux';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import ResizeObserver from 'react-resize-observer';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import StaticAddColumnDropdownComponent from './StaticAddColumnDropdownComponent';
import {
  saveCalendarExercise,
  saveNonDateBasedWorkoutExercise,
  updateReduxCalendarItem,
  updateReduxProgramItem,
  focusNextPreSaveItem,
  setPreSaveTableLocalState,
} from '../../ducks/calendarActions';
import SwapPropDropdownSAQC from './SwapPropDropdownSAQC';
import capitalizeWords from '../../../../shared/utils/capitalizeWords';
import TBportalTooltip from '../../../../shared/components/TBportalTooltip';
import Text from '../../../../shared/components/Text/Text';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';

const FormWrapper = styled('form')`
  display: flex;
  width: 100%;
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;
`;
const PrimaryRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: ${(props) => (props.isAdding ? '16px' : '0px')};
`;

const ValueRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const PrimaryRowValue = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  max-height: ${(props) => (props.isAdding && '24px')}; 
  margin-bottom: 3px;
`;

const RowValue = styled('input')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: ${(props) => props.background};
  border: ${(props) => (!props.isError ? '1px solid #EEEEEE' : '1px solid red')};
  text-align: center;
  border-radius: 4px;
  color: ${(props) => (props.textColor ? props.textColor : '#444444')};

  ::placeholder {
    color: ${(props) => (props.textColor ? props.textColor : '#444444')};
  }
`;

const ShimmerRowValue = styled('div')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  text-align: center;
  border-radius: 6px;
  color: transparent;
  margin-left: 5px;
  margin-right: 5px;
`;

const SetRowValue = styled('input')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: #FCFCFC;
  border: 1px solid #EEEEEE;
  text-align: center;
  border-radius: 4px;
`;

const ShimmerSetRowValue = styled('div')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  text-align: center;
  margin-right: 5px;
`;

const AddColumnButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SaveButtonContainer = styled('button')`
  display: flex;
  background: #10cd8c;
  height: 34px;
  padding-left: 8px;
  padding-right: 8px;
  font-family: 'Nunito Sans';
  color: ${(props) => (props.shimmer ? 'transparent' : 'white')};
  border-radius: 5px;
  font-weight: 700;
  font-size: 13px;
  align-items: center;
  min-width: 56px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  width: 100%;
`;

const AddColumnIcon = styled('div')`
  padding: 4px;
  background: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RemoveIcon = styled('div')`
  padding: 4px 4px 4px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RowsContainer = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-end;
  height: 40px;
  gap: 16px;
`;

const ErrorAndRowsContainer = styled('div')`
display: flex;
flex-direction: column;
width: 100%;
`;

const RowValueContainer = styled('div')`
  width: 100%;
  min-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: ${(props) => (props.shimmer ? '4px' : '0px')};
`;

const SetRowValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 180px;
  width: 100%;
  border-radius: ${(props) => (props.shimmer ? '4px' : '0px')};
`;

const NameAndDropdown = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3px;
`;

const PrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 180px;
  color: ${(props) => (props.shimmer ? 'transparent' : 'inherit')};
  border-radius: ${(props) => (props.shimmer ? '4px' : '0px')};
  padding-top: ${(props) => (props.shimmer ? '0px' : '16px')};
`;

const SetPrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 180px;
  width: 100%;
  color: ${(props) => (props.shimmer ? 'transparent' : 'inherit')};
  border-radius: ${(props) => (props.shimmer ? '4px' : '0px')};
  padding-top: ${(props) => (props.shimmer ? '0px' : '16px')};
`;

const TooltipDataContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px;
  padding-right: 16px;
  padding-left: 16px;
  gap: 10px;
  border-radius: 4px;
  max-width: 250px;
  min-width: 250px;
`;
const TooltipDataContainerAthleteInput = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 16px;
  padding-left: 16px;
  gap: 10px;
  border-radius: 4px;
  max-width: 250px;
`;

const ErrorText = styled(Text)`
  color: red;
  font-size: 12px;
  margin-top: 4px;
  width: 100%;
  max-width: ${(props) => props.maxWidth && props.maxWidth}px;
  margin-left: ${(props) => props.marginLeftForErrorText && props.marginLeftForErrorText}px;
`;

const StaticDropdownAndFillButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 16px;
  margin-bottom: 16px;
  padding-top: 18px;
`;

const SaveButtonContainerText = styled('div')`
  margin-top: 2px;
  font-weight: 700;
  font-family: 'Nunito Sans';
`;

const PreSaveTableSAQC = ({
  coachCompletion,
  completionOnly,
  contentIndex,
  content,
  localAdditionalInfo,
  localDescription,
  swapDropdownSelectedExercise,
  assignedPace,
  date,
  dayNumber,
}) => {
  const dispatch = useDispatch();
  const targetRef = useRef(null);
  const targetRefAthleteInputOnly = useRef(null);
  const rowContainerRef = useRef(null);
  const repsRowValueContainerRef = useRef(null);
  const [maxWidthForErrorText, setMaxWidthForErrorText] = useState(null);
  const [marginLeftForErrorText, setMarginLeftForErrorText] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showAthleteInputOnlyTooltip, setShowAthleteInputOnlyTooltip] = useState(false);
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;
  const endpointFormattedDate = moment(effectiveDate).format('YYYY-MM-DD');
  const calendarContainerScrollPositionTop = useSelector((state) => state.calendar.data.calendarContainerScrollPositionTop);
  const focusTarget = useSelector((state) => state.calendar.data.focusTarget);
  const preSaveTableLocalState = useSelector((state) => state.calendar.data.preSaveTableLocalState);
  const [isAdding, setIsAdding] = useState(false);
  const [setNumberValue, setSetNumberValue] = useState(1);

  const [exerciseData, setExerciseData] = useState({
    reps: null,
  });

  const [error, setError] = useState(null); // Track error message

  /** remove athlete input and prescribed value from initial state of inputs if
   * exercie is completion only
   */
  const primaryRowStateInitialStateIfExerciseIsCompletionOnly = [
    { name: 'sets' },
    { name: 'rest', label: 'Rest (s)' },
    { name: 'reps' },
    { name: 'rest per rep', label: 'Rest Per Rep (s)' },
    { name: 'intensity (bpm)' },
  ];

  const [primaryRows, setPrimaryRows] = useState(content?.inputType === 'C' ? primaryRowStateInitialStateIfExerciseIsCompletionOnly : [
    { name: 'sets' },
    { name: 'rest', label: 'Rest (s)' },
    { name: 'athlete input', label: `${capitalizeWords(content?.inputTypeDescription)} (${content.unit === 'MS' ? 'm:s' : content.unitAbbr})` },
    { name: 'prescribed value', label: 'Prescribed Value' },
    { name: 'reps' },
    { name: 'rest per rep', label: 'Rest Per Rep (s)' },
    { name: 'intensity (bpm)' },
  ]);

  /** remove athlete input and prescribed value from initial state of switch options if
   * exercie is completion only
   */
  const primaryRowSwitchStateInitialStateIfExerciseIsCompletionOnly = {
    sets: true,
    rest: false,
    reps: false,
    'reps per rep': false,
    'intensity (bpm)': false,
  };

  const [primaryRowSwitch, setPrimaryRowSwitch] = useState(content?.inputType === 'C' ? primaryRowSwitchStateInitialStateIfExerciseIsCompletionOnly : {
    sets: true,
    rest: false,
    'prescribed value': false,
    reps: false,
    'reps per rep': false,
    'intensity (bpm)': false,
    'athlete input': true,
  });

  const setPrimaryRowSwitchState = (newState) => {
    setPrimaryRowSwitch(newState);
  };

  const [rest, setRest] = useState(null);
  const [intensityUnit, setIntensityUnit] = useState(null);
  const [intensityValue, setIntensityValue] = useState(null);
  const [prescribedValue, setPrescribedValue] = useState(null);
  const [restPerRep, setRestPerRep] = useState(null);

  /** This useEffect detects if the user chooses a different exercise
   * from the item dropdownn select and updates the pre saved item in redux
   * so that the table structure and content updates to match the selected exercise
   */
  useEffect(() => {
    if (swapDropdownSelectedExercise) {
      const updatedItem = {
        ...swapDropdownSelectedExercise,
        title: swapDropdownSelectedExercise.name,
        exerciseId: parseInt(swapDropdownSelectedExercise.id, 10),
        id: `${swapDropdownSelectedExercise.id}-${generateUniqueId()}`,
        assignedId: `${swapDropdownSelectedExercise.id}-${generateUniqueId()}`,
        preSave: true,
      };
      if (programType === 'free-form-program') {
        dispatch(updateReduxProgramItem(updatedItem, dayNumber || selectedProgramDayNumber, contentIndex));
      } else {
        dispatch(updateReduxCalendarItem(updatedItem, endpointFormattedDate, contentIndex));
      }
    }
  }, [swapDropdownSelectedExercise]);

  useEffect(() => {
    if (!primaryRowSwitch['prescribed value']) {
      setPrescribedValue(null);
    }
    if (!primaryRowSwitch['intensity (bpm)'] && !primaryRowSwitch['intensity (RPE)'] && !primaryRowSwitch['intensity (%)'] && !primaryRowSwitch['intensity (W)']) {
      setIntensityUnit(null);
      setIntensityValue(null);
    }
    if (!primaryRowSwitch.rest) {
      setRest(null);
    }
    if (!primaryRowSwitch['rest per rep']) {
      setRestPerRep(null);
    }
    if (!primaryRowSwitch.reps) {
      const newExerciseData = { ...exerciseData };
      newExerciseData.reps = 0;
      setExerciseData(newExerciseData);
    }
  }, [primaryRowSwitch]);

  // Initialize state from Redux backup if it exists
  useEffect(() => {
    const backup = preSaveTableLocalState[content.assignedId];
    if (backup) {
      if (backup.setNumberValue !== undefined) setSetNumberValue(backup.setNumberValue);
      if (backup.rest !== undefined) setRest(backup.rest);
      if (backup.intensityUnit !== undefined) setIntensityUnit(backup.intensityUnit);
      if (backup.intensityValue !== undefined) setIntensityValue(backup.intensityValue);
      if (backup.prescribedValue !== undefined) setPrescribedValue(backup.prescribedValue);
      if (backup.restPerRep !== undefined) setRestPerRep(backup.restPerRep);
      if (backup.exerciseData !== undefined) setExerciseData(backup.exerciseData);
      if (backup.primaryRowSwitch !== undefined) setPrimaryRowSwitch(backup.primaryRowSwitch);
      if (backup.primaryRows !== undefined) setPrimaryRows(backup.primaryRows);
    }
  }, [content.assignedId, preSaveTableLocalState]);

  // Save current state to Redux backup on blur
  const saveStateToRedux = useCallback(() => {
    const stateObject = {
      setNumberValue,
      rest,
      intensityUnit,
      intensityValue,
      prescribedValue,
      restPerRep,
      exerciseData,
      primaryRowSwitch,
      primaryRows,
    };
    dispatch(setPreSaveTableLocalState(content.assignedId, stateObject));
  }, [
    setNumberValue, rest, intensityUnit, intensityValue, prescribedValue,
    restPerRep, exerciseData, primaryRowSwitch, primaryRows,
    content.assignedId, dispatch,
  ]);

  const setRestFunction = (value) => {
    const intRest = parseInt(value, 10);
    // Prevent negative values
    if (intRest < 0) return;
    setRest(intRest);
  };

  const setIntensityFunction = (value) => {
    // Prevent negative values
    if (parseFloat(value) < 0) return;
    setIntensityValue(value);
  };

  const setPrescribedValueFunction = (value) => {
    // Prevent negative values
    if (parseFloat(value) < 0) return;
    setPrescribedValue(value);
  };

  const handleInputChange = (field, value) => {
    // Prevent negative values for numeric fields
    if ((field === 'prescribed value' || field.includes('intensity')) && parseFloat(value) < 0) {
      return;
    }

    if (field === 'reps') {
      // Check for partial "custom" input
      const trimmedValue = value.trim().toLowerCase();
      if (['c', 'cu', 'cus', 'cust'].includes(trimmedValue)) {
        setError('If you would like to program multiple sets, please enter them as comma separated values, e.g. 12,10,8 to match the number of sets');
        return;
      }

      // Prevent negative values for reps field
      if (value && value.toUpperCase() === 'AMAP') {
        // AMAP is valid, continue
      } else if (value && value.includes('-') && !value.startsWith('-')) {
        // Check for ranges (e.g., "8-12") but not negative numbers
        const parts = value.split('-');
        if (parts.length === 2) {
          const start = parseInt(parts[0], 10);
          const end = parseInt(parts[1], 10);
          if (start < 0 || end < 0) {
            return; // Prevent negative values in ranges
          }
        }
      } else if (value && value.includes('+') && !value.startsWith('-')) {
        // Check for minimum values (e.g., "8+") but not negative numbers
        const numPart = value.replace('+', '');
        if (parseInt(numPart, 10) < 0) {
          return; // Prevent negative minimum values
        }
      } else if (value && !Number.isNaN(Number(value))) {
        // Check for simple numbers (including negative ones)
        if (parseFloat(value) < 0) {
          return; // Prevent negative simple numbers
        }
      }

      const repsArray = value
        .split(',')
        .map((rep) => rep.trim())
        .filter(Boolean);
      const setCount = parseInt(setNumberValue, 10); // Number of sets

      // Check each value and collect invalid ones
      const invalidValues = [];
      repsArray.forEach((rep, index) => {
        let isValid = false;

        if (/^\d+\+?$/.test(rep)) {
          // Single number, optionally followed by a plus sign
          isValid = true;
        } else if (/^\d+-\d+$/.test(rep)) {
          // Range - validate that first number is less than second number
          const [start, end] = rep.split('-').map(Number);
          isValid = start <= end;
        } else if (['AMAP'].includes(rep.toUpperCase())) {
          // AMRAP/AMAP
          isValid = true;
        }

        if (!isValid) {
          invalidValues.push({ value: rep, position: index + 1 });
        }
      });

      const isValidRepsInput = invalidValues.length === 0;

      // Temporary store value for validation
      if (!isValidRepsInput) {
        if (invalidValues.length === 1) {
          setError(`Invalid format: "${invalidValues[0].value}" at position ${invalidValues[0].position}. Use numbers, ranges with lower value first (e.g. 8-12), minimums (e.g. 8+), or "AMAP".`);
        } else {
          const invalidList = invalidValues.map((iv) => `"${iv.value}" (pos ${iv.position})`).join(', ');
          setError(`Invalid format for values: ${invalidList}. Use numbers, ranges with lower value first (e.g. 8-12), minimums (e.g. 8+), or "AMAP".`);
        }
        return;
      }

      // Only normalize when fully valid
      if (repsArray.length === setCount || repsArray.length === 1) {
        const normalizedReps = repsArray.length === 1 ? Array(setCount).fill(repsArray[0]) : repsArray;
        setExerciseData((prev) => ({
          ...prev,
          reps: normalizedReps,
        }));
        setError(null); // Clear error
      } else {
        // Allow partial input, but don't overwrite reps
        setExerciseData((prev) => ({
          ...prev,
          reps: repsArray,
        }));
        setError(
          `Expected ${setCount} values or 1 value (to apply to all sets), but received ${repsArray.length} values.`,
        );
      }
    } else if (field === 'sets') {
      // Handle sets field change and re-validate reps
      setSetNumberValue(value);

      // Re-validate existing reps against new set count
      if (exerciseData.reps && exerciseData.reps.length > 0) {
        const newSetCount = parseInt(value, 10);
        const repsArray = exerciseData.reps;

        // Check if reps count matches new set count
        if (repsArray.length !== newSetCount && repsArray.length !== 1 && repsArray.length > 0) {
          setError('Enter a number for reps to apply to all sets.');
        } else {
          setError(null); // Clear error if valid
        }
      }
    } else {
      // Update other fields normally
      setExerciseData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const typeFormatter = (typeDescription) => {
    if (typeDescription === 'lift') {
      return 'lift';
    }
    if (typeDescription === 'cardio') {
      return 'saq+c';
    }
    if (typeDescription === 'circuit') {
      return 'circuit';
    }
    return '';
  };

  const handleRepsBlur = () => {
    if (Array.isArray(exerciseData.reps)) {
      const setCount = parseInt(setNumberValue, 10);

      // Check if all reps are valid and collect invalid ones
      const invalidValues = [];
      exerciseData.reps.forEach((rep, index) => {
        const isValid = /^\d+\+?$/.test(rep) // Single number, optionally followed by a plus sign
          || /^\d+-\d+$/.test(rep) // Range
          || ['AMAP'].includes(rep.toUpperCase()); // AMRAP/AMAP

        if (!isValid) {
          invalidValues.push({ value: rep, position: index + 1 });
        }
      });

      // If any rep is invalid, show specific error
      if (invalidValues.length > 0) {
        if (invalidValues.length === 1) {
          setError(`Invalid format: "${invalidValues[0].value}" at set ${invalidValues[0].position}. Use numbers, ranges with lower value first (e.g. 8-12), minimums (e.g. 8+), or "AMAP".`);
        } else {
          const invalidList = invalidValues.map((iv) => `"${iv.value}" (set ${iv.position})`).join(', ');
          setError(`Invalid format for values: ${invalidList}. Use numbers, ranges with lower value first (e.g. 8-12), minimums (e.g. 8+), or "AMAP".`);
        }
        return;
      }

      // Check if the number of reps matches the set count
      if (exerciseData.reps.length !== setCount && exerciseData.reps.length !== 1) {
        setError(`Expected ${setCount} values or 1 value (to apply to all sets), but have ${exerciseData.reps.length} values.`);
      } else {
        setError(null); // Clear error if valid
      }
    } else {
      setError(`Invalid input type. Expected comma-separated values but received: ${typeof exerciseData.reps}.`);
    }
  };

  const errorAddReset = () => {
    setIsAdding(false);
  };

  /** this function and the useEffect below handle calculations for dynamic width changes
   * so that the error text for incorrect rep inputs always stays under
   * the rep input box and that it adjusts with resize and added inputs
   */
  const handleResize = () => {
    const rowsContainerLeftPosition = rowContainerRef?.current?.getBoundingClientRect()?.left;
    if (repsRowValueContainerRef?.current) {
      const leftPositionOfRepsRowValueContainer = repsRowValueContainerRef?.current.getBoundingClientRect()?.left;
      setMarginLeftForErrorText(leftPositionOfRepsRowValueContainer - rowsContainerLeftPosition);
      setMaxWidthForErrorText(repsRowValueContainerRef?.current.getBoundingClientRect()?.width);
    }
  };

  /** see above function note */
  useEffect(() => {
    if (rowContainerRef?.current && repsRowValueContainerRef?.current) {
      handleResize();
    }
  }, [rowContainerRef?.current, repsRowValueContainerRef?.current, primaryRowSwitch]);

  const handleSaveCalendarExercise = (contentIndexParam) => {
    const setSubmissionArray = [];
    setIsAdding(true);
    for (let i = 0; i < setNumberValue; i += 1) {
      let repsValue;
      if (exerciseData.reps) {
        if (Array.isArray(exerciseData.reps)) {
          // Handle numerical array
          repsValue = exerciseData.reps[i]
            || exerciseData.reps[exerciseData.reps.length - 1]
            || 0;
        } else if (typeof exerciseData.reps === 'string') {
          // Handle single non-numerical string
          repsValue = exerciseData.reps;
        } else {
          repsValue = 0; // Default fallback
        }
      }
      const setObject = {
        setNumber: i + 1,
      };
      if (repsValue) {
        setObject.reps = repsValue;
      }
      if (prescribedValue) {
        setObject.prescribedValue = prescribedValue;
      }
      if (intensityValue) {
        setObject.intensityValue = intensityValue;
      }
      if (restPerRep) {
        setObject.restPerRep = restPerRep;
      }
      setSubmissionArray.push(setObject);
    }
    const submissionObject = {
      coachCompletion,
      completionOnly,
      /** Conditional key based on programType: "date" OR "dayNumber" */
      [programType === 'free-form-program' ? 'dayNumber' : 'date']:
          programType === 'free-form-program'
            ? dayNumber
            : moment(effectiveDate).format('YYYY-MM-DD'),
      exerciseId: content.exerciseId,
      repIntensityUnit: null,
      type: typeFormatter(content.typeDescription),
      sets: setSubmissionArray,
      showSessionBreakItems: false,
    };
    if (localDescription || content.description) {
      submissionObject.description = localDescription || content.description;
    }
    if (localAdditionalInfo || content.additionalInfo) {
      submissionObject.additionalInfo = localAdditionalInfo || content.additionalInfo;
    }
    if (rest) {
      submissionObject.restTime = rest;
    }
    if (intensityUnit) {
      submissionObject.repIntensityUnit = intensityUnit;
    }
    if (assignedPace) {
      submissionObject.pacing = assignedPace;
    }
    if (content.groupingLetter) {
      submissionObject.groupingLetter = content.groupingLetter;
    }
    const formattedDate = moment(effectiveDate).format('YYYY-MM-DD');
    if (programType === 'free-form-program') {
      dispatch(saveNonDateBasedWorkoutExercise(
        currentUser,
        contentIndexParam,
        submissionObject,
        dayNumber,
        errorAddReset,
        {
          onSuccess: () => {
          // Trigger focus to next preSave item
            // dispatch(focusNextPreSaveItem(contentIndexParam, effectiveDate));
          },
        },
        content.assignedId,
      ));
    } else {
      dispatch(saveCalendarExercise(
        currentUser,
        contentIndexParam,
        submissionObject,
        formattedDate,
        errorAddReset,
        {
          onSuccess: () => {
          // Trigger focus to next preSave item
            dispatch(focusNextPreSaveItem(contentIndexParam, effectiveDate));
          },
        },
        content.assignedId,
      ));
    }
  };

  const rowValueDecider = (name, shouldShimmer) => {
    if (shouldShimmer) {
      return (
        <Shimmer>
          <RowValueContainer shimmer>
            <ShimmerRowValue />
          </RowValueContainer>
        </Shimmer>
      );
    }
    if (name === 'rest') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={rest}
            onChange={(e) => setRestFunction(e.target.value)}
            onBlur={saveStateToRedux}
            onKeyDown={(e) => {
              if (e.key === '-') {
                e.preventDefault();
              }
            }}
            background='#FCFCFC'
            data-focus-target={
              (name === 'rest' && primaryRowSwitch.rest && !primaryRowSwitch.sets && !primaryRowSwitch.reps)
                ? content.assignedId
                : undefined
            }
          />
        </RowValueContainer>
      );
    }
    if (name === 'prescribed value') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={prescribedValue}
            onChange={(e) => setPrescribedValueFunction(e.target.value)}
            onBlur={saveStateToRedux}
            onKeyDown={(e) => {
              if (e.key === '-') {
                e.preventDefault();
              }
            }}
            background='#FCFCFC'
            data-focus-target={
              (name === 'prescribed value' && primaryRowSwitch['prescribed value'] && !primaryRowSwitch.sets && !primaryRowSwitch.reps && !primaryRowSwitch.rest)
                ? content.assignedId
                : undefined
            }
          />
        </RowValueContainer>
      );
    }
    if (name === 'athlete input') {
      return (
        <RowValueContainer>
          <RowValue
            placeholder='-'
            /** disable the ability to edit this field */
            disabled
            background='#FCFCFC'
            textColor='#BDBDBD'
          />
        </RowValueContainer>
      );
    }
    if (name === 'rest per rep') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={restPerRep}
            background='#FCFCFC'
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              // Prevent negative values
              if (value < 0) return;
              setRestPerRep(value);
            }}
            onBlur={saveStateToRedux}
            onKeyDown={(e) => {
              if (e.key === '-') {
                e.preventDefault();
              }
            }}
            data-focus-target={
              (name === 'rest per rep' && primaryRowSwitch['rest per rep'] && !primaryRowSwitch.sets && !primaryRowSwitch.reps && !primaryRowSwitch.rest && !primaryRowSwitch['prescribed value'])
                ? content.assignedId
                : undefined
            }
          />
        </RowValueContainer>
      );
    }
    if (name === 'intensity (bpm)' || name === 'intensity (RPE)' || name === 'intensity (%)' || name === 'intensity (W)') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={intensityValue}
            onChange={(e) => setIntensityFunction(e.target.value)}
            onBlur={saveStateToRedux}
            onKeyDown={(e) => {
              if (e.key === '-') {
                e.preventDefault();
              }
            }}
            background='#FCFCFC'
            data-focus-target={
              ((name === 'intensity (bpm)' || name === 'intensity (RPE)' || name === 'intensity (%)' || name === 'intensity (W)')
                && (primaryRowSwitch['intensity (bpm)'] || primaryRowSwitch['intensity (RPE)'] || primaryRowSwitch['intensity (%)'] || primaryRowSwitch['intensity (W)'])
                && !primaryRowSwitch.sets && !primaryRowSwitch.reps && !primaryRowSwitch.rest && !primaryRowSwitch['prescribed value'] && !primaryRowSwitch['rest per rep'])
                ? content.assignedId
                : undefined
            }
          />
        </RowValueContainer>
      );
    }
    return (
      <RowValueContainer ref={repsRowValueContainerRef}>
        <RowValue
          isError={name === 'reps' && error}
          type='text'
          background='#FCFCFC'
          onChange={(e) => handleInputChange(name, e.target.value)}
          onBlur={name === 'reps' ? () => {
            handleRepsBlur();
            saveStateToRedux();
          } : saveStateToRedux}
          onKeyDown={(e) => {
            // For reps, prevent minus at the beginning
            if (name === 'reps' && e.key === '-' && e.target.selectionStart === 0) {
              e.preventDefault();
            }
          }}
          data-focus-target={
            // Add focus target to the first editable field that's visible (sets field takes priority)
            (name === 'reps' && primaryRowSwitch.reps && !primaryRowSwitch.sets)
              ? content.assignedId
              : undefined
          }
        />
      </RowValueContainer>
    );
  };

  const updateColumnName = useCallback((oldName, newName) => {
    setPrimaryRows(
      (prevRows2) => prevRows2.map(
        (row) => (row.name === oldName ? { ...row, name: newName } : row),
      ),
    );

    setPrimaryRowSwitch((prevSwitch) => ({
      ...prevSwitch,
      [oldName]: false,
      [newName]: true,
    }));
  }, []);

  const findCorrectUnit = (unitContent) => {
    if (unitContent?.unitAbbr) {
      return `(${unitContent?.unitAbbr === 'wgt' ? 'lbs' : unitContent?.unitAbbr})`;
    }
    return '';
  };

  // This useEffect is responsible for managing focus on input fields when the focusTarget changes.
  // It checks if the current focusTarget's assignedId matches the content's assignedId.
  // If they match, it finds the first input element with a data-focus-target attribute equal to the content's assignedId.
  // Once found, it sets a timeout to focus on this input element after a short delay, ensuring the DOM is ready.
  useEffect(() => {
    if (focusTarget?.assignedId === content.assignedId) {
      const firstInput = document.querySelector(`[data-focus-target="${content.assignedId}"]`);
      if (firstInput) {
        setTimeout(() => {
          firstInput.focus();
        }, 100); // Small delay to ensure DOM is ready
      }
    }
  }, [focusTarget, content.assignedId]);

  return (
    <FormWrapper onSubmit={(e) => {
      e.preventDefault();
      handleSaveCalendarExercise(contentIndex);
    }}
    >
      <Container>
        <PrimaryRow isAdding={isAdding}>
          {primaryRows.map((primaryRow) => (
            primaryRowSwitch[primaryRow.name] ? (
              primaryRow.name === 'sets' ? !isAdding ? <SetPrimaryValueContainer>{capitalizeWords(primaryRow.name)}</SetPrimaryValueContainer> : <Shimmer><SetPrimaryValueContainer shimmer>{primaryRow.name}</SetPrimaryValueContainer></Shimmer> : (
                !isAdding ? (
                  <PrimaryValueContainer>
                    <PrimaryRowValue isAdding={isAdding}>
                      {(primaryRow.name === 'reps') || (primaryRow.name === 'athlete input') ? (
                        <NameAndDropdown
                          ref={primaryRow.name === 'reps' ? targetRef : targetRefAthleteInputOnly}
                        >
                          {(primaryRow.name === 'reps' || (primaryRow.name === 'athlete input' && !completionOnly)) && (
                            <IcomoonReact
                              iconSet={iconSet}
                              size={14}
                              icon='info2'
                              color='rgba(189, 189, 189, 1)'
                              style={{ cursor: 'pointer' }}
                              onMouseEnter={() => {
                                if (primaryRow.name === 'reps') {
                                  setShowTooltip(true);
                                }
                                if (primaryRow.name === 'athlete input' && !completionOnly) {
                                  setShowAthleteInputOnlyTooltip(true);
                                }
                              }}
                              onMouseLeave={() => {
                                if (primaryRow.name === 'reps') {
                                  setShowTooltip(false);
                                }
                                if (primaryRow.name === 'athlete input') {
                                  setShowAthleteInputOnlyTooltip(false);
                                }
                              }}
                            />
                          )}
                          {primaryRow.name === 'reps' && showTooltip && (
                          <TBportalTooltip targetRef={targetRef} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowTooltip} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainer>
                              <Text fontSize='13px' fontWeight={400} color='white'>Accepted Inputs</Text>
                              <ul style={{ paddingLeft: '20px' }}>
                                <li>
                                  <Text fontSize='13px' fontWeight={400} color='white'>Absolute (e.g. 5)</Text>
                                </li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>Comma Separated (e.g. 12,10,8)</Text></li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>Range (e.g. 8-12)</Text></li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>Minimum (e.g. 8+)</Text></li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>&quot;AMAP&quot; for as many as possible</Text></li>
                              </ul>
                            </TooltipDataContainer>
                          </TBportalTooltip>
                          )}
                          {primaryRow.name === 'athlete input' && showAthleteInputOnlyTooltip && !completionOnly && (
                          <TBportalTooltip targetRef={targetRefAthleteInputOnly} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowAthleteInputOnlyTooltip} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainerAthleteInput>
                              <Text fontSize='13px' fontWeight={400} color='white'>Athlete input only</Text>
                            </TooltipDataContainerAthleteInput>
                          </TBportalTooltip>
                          )}
                          <SwapPropDropdownSAQC
                        /** always visible except for athlete input, coach should not be able to edit athlete input */
                            visible={primaryRow.name !== 'athlete input'}
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            setIntensityUnit={setIntensityUnit}
                            name={(primaryRow?.label || capitalizeWords(primaryRow.name))}
                            unit={primaryRow.name === 'prescribed value' ? findCorrectUnit(content) : null}
                          />
                        </NameAndDropdown>
                      ) : (
                        <NameAndDropdown>
                          <SwapPropDropdownSAQC
                          /** always visible except for athlete input, coach should not be able to edit athlete input */
                            visible={primaryRow.name !== 'athlete input'}
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            setIntensityUnit={setIntensityUnit}
                            name={(primaryRow?.label || capitalizeWords(primaryRow.name))}
                            unit={primaryRow.name === 'prescribed value' ? findCorrectUnit(content) : null}
                          />
                        </NameAndDropdown>
                      )}
                    </PrimaryRowValue>
                  </PrimaryValueContainer>
                ) : (
                  <Shimmer>
                    <PrimaryValueContainer shimmer>
                      <PrimaryRowValue isAdding={isAdding}>
                        <NameAndDropdown>
                          {primaryRow.name === 'prescribed value' ? capitalizeWords('Prescribed Value') : capitalizeWords(primaryRow.name)}
                          {' '}
                          {primaryRow.name === 'prescribed value' ? findCorrectUnit(content) : null}
                        </NameAndDropdown>
                      </PrimaryRowValue>
                    </PrimaryValueContainer>
                  </Shimmer>
                )
              )
            ) : null
          ))}
          {/* {!isAdding ? (
            <div style={{
              minWidth: 56,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            >
              <StaticAddColumnDropdownComponent
                primaryRows={primaryRows}
                primaryRowSwitch={primaryRowSwitch}
                setPrimaryRowSwitch={setPrimaryRowSwitch}
                size={12}
                setIntensityUnit={setIntensityUnit}
                setPrimaryRowSwitchState={setPrimaryRowSwitchState}
              >
                <AddColumnButtonContainer className='add-column-button'>
                  <AddColumnIcon>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='plus'
                      color='white'
                    />
                  </AddColumnIcon>
                </AddColumnButtonContainer>
              </StaticAddColumnDropdownComponent>
            </div>
          ) : (
            <div style={{
              minWidth: 56,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            >
              <Shimmer>
                <div style={{
                  minHeight: 24,
                  minWidth: 24,
                  borderRadius: 3,
                }}
                />
              </Shimmer>
            </div>
          )} */}
        </PrimaryRow>
        <ValueRow>
          <ErrorAndRowsContainer>
            {/* <form onSubmit={(e) => {
            e.preventDefault();
            handleSaveCalendarExercise(contentIndex);
          }}
          > */}
            <RowsContainer ref={rowContainerRef}>
              <ResizeObserver
                onResize={(rect) => {
                  handleResize(rect);
                }}
              />
              {primaryRows.map((primaryRow) => (
                primaryRowSwitch[primaryRow.name] ? (
                  primaryRow.name === 'sets' ? (
                    !isAdding ? (
                      <SetRowValueContainer>
                        <SetRowValue
                          type='number'
                          value={setNumberValue}
                          onChange={(e) => {
                            const value = parseInt(e.target.value, 10);
                            // Prevent negative values
                            if (value < 0) return;
                            handleInputChange('sets', value);
                          }}
                          onBlur={saveStateToRedux}
                          onKeyDown={(e) => {
                            if (e.key === '-') {
                              e.preventDefault();
                            }
                          }}
                          data-focus-target={primaryRowSwitch.sets ? content.assignedId : undefined}
                        />
                      </SetRowValueContainer>
                    ) : (
                      <Shimmer>
                        <SetRowValueContainer shimmer>
                          <ShimmerSetRowValue />
                        </SetRowValueContainer>
                      </Shimmer>
                    )
                  )
                    : rowValueDecider(primaryRow.name, isAdding)
                ) : null
              ))}
              {/* {!isAdding ? (
                <SaveButtonContainer type='submit'>
                  FILL
                  <RemoveIcon>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='down-arrow'
                      color='white'
                    />
                  </RemoveIcon>
                </SaveButtonContainer>
              ) : (
                <Shimmer>
                  <SaveButtonContainer shimmer>
                    FILL
                    <RemoveIcon>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={12}
                        icon='down-arrow'
                        color='transparent'
                      />
                    </RemoveIcon>
                  </SaveButtonContainer>
                </Shimmer>
              )} */}
            </RowsContainer>
            {error && <ErrorText marginLeftForErrorText={marginLeftForErrorText} maxWidth={maxWidthForErrorText}>{error}</ErrorText>}
            {/* </form> */}
          </ErrorAndRowsContainer>
        </ValueRow>
      </Container>
      <StaticDropdownAndFillButtonContainer>
        <>
          {!isAdding ? (
            <div style={{
              minWidth: 56,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            >
              <StaticAddColumnDropdownComponent
                primaryRows={primaryRows}
                primaryRowSwitch={primaryRowSwitch}
                setPrimaryRowSwitch={setPrimaryRowSwitch}
                size={12}
                setIntensityUnit={setIntensityUnit}
                setPrimaryRowSwitchState={setPrimaryRowSwitchState}
              >
                <AddColumnButtonContainer className='add-column-button'>
                  <AddColumnIcon>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='plus'
                      color='white'
                    />
                  </AddColumnIcon>
                </AddColumnButtonContainer>
              </StaticAddColumnDropdownComponent>
            </div>
          ) : (
            <div style={{
              minWidth: 56,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            >
              <Shimmer>
                <div style={{
                  minHeight: 24,
                  minWidth: 24,
                  borderRadius: 3,
                }}
                />
              </Shimmer>
            </div>
          )}
        </>
        <>
          {!isAdding ? (
            <SaveButtonContainer type='submit'>
              <SaveButtonContainerText>
                ADD
              </SaveButtonContainerText>
              <RemoveIcon>
                <IcomoonReact
                  iconSet={iconSet}
                  size={12}
                  icon='down-arrow'
                  color='white'
                />
              </RemoveIcon>
            </SaveButtonContainer>
          ) : (
            <Shimmer>
              <SaveButtonContainer shimmer>
                <SaveButtonContainerText>
                  ADD
                </SaveButtonContainerText>
                <RemoveIcon>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={12}
                    icon='down-arrow'
                    color='transparent'
                  />
                </RemoveIcon>
              </SaveButtonContainer>
            </Shimmer>
          )}
        </>
      </StaticDropdownAndFillButtonContainer>
    </FormWrapper>
  );
};

PreSaveTableSAQC.propTypes = {
  coachCompletion: PropTypes.bool.isRequired,
  completionOnly: PropTypes.bool.isRequired,
  contentIndex: PropTypes.number.isRequired,
  content: PropTypes.instanceOf(Object).isRequired,
  swapDropdownSelectedExercise: PropTypes.instanceOf(Object).isRequired,
  localAdditionalInfo: PropTypes.string,
  localDescription: PropTypes.string,
  assignedPace: PropTypes.string,
  date: PropTypes.string,
  dayNumber: PropTypes.string,
};

PreSaveTableSAQC.defaultProps = {
  localAdditionalInfo: '',
  localDescription: '',
  assignedPace: '',
  date: null,
  dayNumber: null,
};

export default PreSaveTableSAQC;
